<template>
  <div id="contact-wrap">
    <div>
      <Icon type="md-close"
            size="15"
            @click="choosePop" />
    </div>
    <div class="contact-box">
      <div class="contact-left">
        <div class="contact-padding">
          <div class="contact-type">
            <img src="../assets/img/contact_icon_phone.png"
                 alt="">
            联系电话
          </div>
          <div class="contact-div">电话号码：<span>{{serverList.server_mobile}}</span></div>
          <div class="contact-div">工作时间：<span>周一至周五（节假日除外） 09:00-18:00</span></div>
        </div>
      </div>
      <div class="contact-right">
        <div class="contact-padding">
          <div class="contact-type">
            <img src="../assets/img/contact_icon_wechat.png"
                 alt="">
            微信二维码
          </div>
          <div class="contact-div">
            <img :src="serverList.wechat_code"
                 alt="">
          </div>
        </div>
      </div>
    </div>
    <Spin size="large"
          fix
          v-show="loading"></Spin>
  </div>
</template>

<script>
import { requestAjax } from '@/api/user'
import { Spin, Icon } from 'view-design'
export default {
  name: "Popup",
  components: {
    Spin,
    Icon
  },
  data: function () {
    return {
      loading: false,
      serverList: {
        wechat_code: '',
        server_mobile: ''
      }
    }
  },
  mounted: function () {
    var that = this
    this.loading = true
    requestAjax({}, '/index/index/getServerConfig', 'post').then(response => {
      that.loading = false
      that.serverList.wechat_code = response.data.wechat_code
      that.serverList.server_mobile = response.data.server_mobile;
    }).catch(error => {
      that.loading = false
      console.log(error)
      that.$Message.error('加载客服信息失败,请稍后再试!')
    })
  },
  methods: {
    choosePop: function () {
      this.$emit('chooseContact')
    }
  }
}
</script>

<style>
#contact-wrap {
  z-index: 9999999;
  background-color: #ffffff;
  /* position: absolute; */
  /* display: flex; */
  position: fixed;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #666666;
  min-width: 400px;
  -moz-opacity: 1;
  opacity: 1;
  filter: alpha(opacity=100);
  box-shadow: 0px 1px 1px 1px #00000012;
}
#contact-wrap .contact-box {
  padding: 0 30px;
}
#contact-wrap .contact-box .contact-left {
  float: left;
  width: 60%;
}
#contact-wrap .contact-box .contact-right {
  float: left;
  width: 40%;
}
#contact-wrap .contact-box .contact-left .contact-padding,
#contact-wrap .contact-box .contact-right .contact-padding {
  padding: 25px 5px;
}
#contact-wrap .contact-box .contact-type {
  padding-bottom: 20px;
  font-family: Alibaba-PuHuiTi-M;
  font-size: 16px;
  color: #222222;
}
#contact-wrap .contact-box .contact-type img {
  width: 24px;
  height: 24px;
}
#contact-padding .contact-div {
  padding: 3px 0;
}
#contact-padding .contact-div img {
  height: 100%;
  width: 100%;
}
@media (min-width: 768px) {
  #contact-wrap {
    width: 40%;
    /* margin: -430px 30%; */
    margin: auto 30%;
    top: 31%;
  }
}
@media (min-width: 992px) {
  #contact-wrap {
    width: 37%;
    /* margin: -430px 31.5%; */
    margin: auto 31.5%;
    top: 33%;
  }
}
@media (min-width: 1200px) {
  #contact-wrap {
    width: 33%;
    /* margin: -430px 33.5%; */
    margin: auto 33.5%;
    top: 35%;
  }
}
@media (min-width: 1400px) {
  #contact-wrap {
    width: 30%;
    /* margin: -470px 35%; */
    margin: auto 35%;
    top: 37%;
  }
}
</style>
<style scoped>
>>> .ivu-icon-md-close {
  float: right;
  margin-right: 10px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue